// Settings sheet help (the "?" at the top of the Settings sheet, beside the close button). Plain
// words; keep it in step with the screen (apps/mobile/src/olmps/SettingsSheet.tsx and settings/).
import type { ScreenHelpContent } from '../../v10/ScreenHelp';

export const settingsHelp: ScreenHelpContent = {
  title: 'Settings',
  intro:
    'Settings is where you change how the app works for you. It has two parts: General, for the whole app, and one page for each deity, for that deity\'s tool. Tap a row to open it. The ‹ at the top left takes you back one page.',
  sections: [
    {
      heading: 'General',
      items: [
        { term: 'App', text: 'Night, Day or Live theme. Replay the SyQi guided setup. Pick the buttons in the top-right of the home screen (Home is always first). Choose what shows in the side menu and in what order. Choose whether a missed week close shows when you open the app. Send a test reminder that arrives in 10 seconds.' },
        { term: 'Game', text: 'Morning and evening session times. Which days count and which day closes the week. The climb: how many actions, Days, Aims and Goals it takes to acquire a deity. The seat window. The alignment windows. The green ranges NUMA aims for. The widgets in your morning and evening sessions.' },
        { term: 'SyQi', text: 'Which tools show in each ORDER section of the SyQi dashboard, and a note telling SyQi how you want your daily overview to work.' },
        { term: 'Council', text: 'A button to open the Council. Whether replies are read aloud (Conference), whether the mic listens by itself, whether SyQi closes each round, who answers (everyone seated, or only who you name), how many deities speak per round, and who is seated by default.' },
        { term: 'Trash & Archive', text: 'Things you deleted or archived. Restore one, delete it for good, or empty the whole list.' },
        { term: 'Account', text: 'Change your password, sign out, or delete your account.' },
      ],
    },
    {
      heading: 'The deities',
      body: [
        'Below General on the first page is a list of deities, each with a one-word job. Tap one to open every setting that deity owns.',
        'These deities have settings: ASTRA (how the compass spins and how quickly a project counts as drifting in each area), HRMEZ (how captured items are sorted, plus folders, routing rules and Google Drive), KYRS (task groups, values and time estimates), KRNOS (the calendar), TKNE (project templates, forms and labels), METIS (miss reasons, nail timer, templates and the Pomodoro timer), CLIO (journal entry types) and ARGOS (activity categories and their limits, which the desktop browser extension uses).',
        'The rest say they have nothing to set up. Everything happens in their tool.',
      ],
    },
    {
      heading: 'Saving',
      body: [
        'Most settings save the moment you change them. There is no Save button.',
        'Changing your password is the exception: type it twice and press Update Password.',
      ],
    },
    {
      heading: 'Careful',
      body: ['Delete account and Delete Forever cannot be undone.'],
    },
  ],
};
